export const validateOffering = (
  data,
  { isUpdate = false } = {}
) => {
  const errors = {};

  if (
    !data.name ||
    typeof data.name !== "string" ||
    data.name.trim().length < 2
  ) {
    errors.name =
      "Offering name must be at least 2 characters";
  }

  if (!data.categoryId) {
    errors.categoryId =
      "Category is required";
  }

  if (!data.type) {
    errors.type =
      "Offering type is required";
  }

  if (
    data.shortDescription !== undefined &&
    data.shortDescription !== null &&
    data.shortDescription.length > 500
  ) {
    errors.shortDescription =
      "Short description cannot exceed 500 characters";
  }

  if (
    data.displayOrder !== undefined &&
    (
      !Number.isInteger(
        Number(data.displayOrder)
      ) ||
      Number(data.displayOrder) < 0
    )
  ) {
    errors.displayOrder =
      "Display order must be a non-negative integer";
  }

  if (
    isUpdate &&
    data.isActive !== undefined &&
    typeof data.isActive !== "boolean"
  ) {
    errors.isActive =
      "isActive must be boolean";
  }

  return errors;
};


export const validatePricingPlan = (
  data,
  { isUpdate = false } = {}
) => {
  const errors = {};

  if (
    !data.name ||
    typeof data.name !== "string" ||
    data.name.trim().length < 2
  ) {
    errors.name =
      "Pricing plan name must be at least 2 characters";
  }

  if (
    !data.pricingType ||
    !["FIXED", "CUSTOM"].includes(
      data.pricingType
    )
  ) {
    errors.pricingType =
      "Pricing type must be FIXED or CUSTOM";
  }

  if (
    data.pricingType === "FIXED" &&
    (
      data.price === undefined ||
      data.price === null ||
      Number(data.price) < 0
    )
  ) {
    errors.price =
      "Price is required for FIXED pricing";
  }

  if (
    data.pricingType === "CUSTOM" &&
    data.price !== undefined &&
    data.price !== null
  ) {
    errors.price =
      "Price must be null for CUSTOM pricing";
  }

  if (
    data.currency !== undefined &&
    (
      typeof data.currency !== "string" ||
      data.currency.length !== 3
    )
  ) {
    errors.currency =
      "Currency must contain exactly 3 characters";
  }

  if (
    data.displayOrder !== undefined &&
    (
      !Number.isInteger(
        Number(data.displayOrder)
      ) ||
      Number(data.displayOrder) < 0
    )
  ) {
    errors.displayOrder =
      "Display order must be a non-negative integer";
  }

  return errors;
};